export const rewriteCdnUrl = (s: string): string => {
  const url = new URL(s);
  return `https://app.happypatrons.net/cdn/${url.pathname}`;
};
